import React, { Component } from "react";

class Nomenclature extends Component {
  render() {
    return (
      <div className="container">
        <div className="jumbotron">
          <br></br>
          <h2>Exon nomenclature</h2>
          <h5>
            The exon nomenclature comprises 6 letter codes separated by (.) and is divided into three following alphanumeric blocks detailing attributes as defined.
          </h5>
          <br />
          <h3 align="center">
            <span style={{ color: "SeaGreen" }}>[UTMDR].[(-2)-n].</span>
            <span style={{ color: "MediumVioletRed" }}>[GAF].[1-n].</span>
            <span style={{ color: "Teal" }}>[ncb0].[0-n]</span>
          </h3>
          <br />
          <ul>
            <li>
              <h5 style={{ color: "SeaGreen" }}>
              BLOCK 1 -> Describes global and local translation output and its consistency of exons among all transcripts and current transcripts.
              </h5>
              <br /> <b>U:</b> Exons, which remain part of Untranslated region
              UTR in every transcript; numeric code is -2
              <br />
              <b>T</b>: Exons, which are always part of the CDS region; numeric code is -1 to n.

              <ul>
                <li>
                  {" "}
                  -1 depict a premature stop codon in the upstream exon, and hence this cannot code for amino acid
                </li>
                <li>
                  {" "}
                  0, means it is part of CDS but CGC span is only 1 nucleotide
                </li>
                <li>
                  1 means it is contributing amino acids in transcripts, and
                </li>
                <li>
                  {" "}
                  2  or more depict, this exon has varying/different amino acids contribution from transcript to transcript (resulting from FSE in upstream exon, skipped exon and ATI/ATT in this exon)
                </li>
              </ul>
              <b>M:</b> Exons, which are one nucelotide long and cannot code for amino acid; numeric code is 0 <br />
              <b>D:</b> Exons, which can be part of both CDS and UTR varying from transcript to transcript; numeric code is -2 when it is a part of UTR and -1 to n when it is part of CDS (same as above U and T cases) <br />
              <b>R:</b> Special cases of intron retention (described in the end)
            </li>
            <br />
            <li>
              <h5 style={{ color: "MediumVioletRed" }}>
                BLOCK 2 -> Describes exon’s inclusion frequency and their nature along with rank
              </h5>
              <br /> <b>G</b>: Constitutive (or Global) exons are present in all
              the transcripts <br />
              <b>A</b>: Alternate exons are not present in all transcripts
              <br /> <b>F</b>: Exons, which when considered with their alternate
              splicing sites, can be found in every transcript <br />Numeric code here
              gives a serial identifier (from 1 to n) to the exon within each of
              the above-described categories (Decided after sorting the RSOEx by genomic coordinates)
            </li>
            <br />
            <li>
              <h5 style={{ color: "Teal" }}>
                BLOCK 3 -> Describes choice of alternate splice site and frequency of occurrence
              </h5>
              <br />
              All these modifications are assigned names by comparing them to
              the RSOEx.{" "}
              <br />
              <b>n: </b> 3’ splice site of upstream intron is changed, leading
              to extension or constriction of exon length from its 5’ end <br />
              <b>c:</b> 5’ splice site of downstream intron is changed, leading
              to extension or constriction of exon length from its 3’ end <br />
              <b>b</b>: 5’ splice site of downstream intron and 3’ splice site
              of upstream intron both are changed simultaneously<br />Numeric code
              here also gives a serial identifier (from 0 to n) to the exon
              within each of the above described categories. <br />
              <b>0</b>: denotes the original exon as in the RSOEx of that gene.
              Numeric code will be 0 in this case.
            </li>
            <br />
            <li>
              <h5 style={{ color: "Crimson" }}>Intron Retention Cases</h5> They are enlisted as identifier having 5 separate parts (separated by ‘:’)
              <ul>
                <li>
                  R is the first letter detailing it as a retention case.
                </li>
                <li>
                  Numeric code (-2 to n) as previously described in block 1.
                </li>
                <li>
                  6-letter identifier of the exon (separated by ‘,’) from which the intron is retained
                </li>
                <li>
                  Serial number(0 to n) of the retention event from that exon
                </li>
                <li>
                  6 letter identifier of exon upto which the intron has been retained.
                </li>
              </ul>
            </li>
          </ul>
          <p>
            <b>Glossary:</b> Untranslated Region(UTR), Coding
            Sequence(CDS), Coding Genomic Coordinates(CGC), Frame Shift
            Events(FSE),  Alternative Transcription
            Initiation(ATI), Alternative Transcription Termination(ATT),
            Principal Isoform(PI), Reference Set of Exons (RSOEx)
          </p>
        </div>
      </div>
    );
  }
}

export default Nomenclature;
